
// import { CouponLogResponse, CouponLog } from "../types/coupon";
import { apiClient, ApiClientConfig } from "api";
export type CraeteTitleCmsrDTO = {
  title: string,
  is_active: boolean,
}
export const AgentsApiService = () => {
  const getAgentList = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `/admin/agent/loginlogoutlogs_agent`,
      params,
    });

    return response.data;
  };
  const getCouponList = async (
    params: any,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `/admin/agentparticipant/couponlog`,
      params,
    });

    return response.data;
  };
  const createNotificationType = async (payload: CraeteTitleCmsrDTO) => {
    const response = await apiClient({
      endpoint: `/admin/announcement/type`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };
  const createNotificationList = async (payload: CraeteTitleCmsrDTO) => {
    const response = await apiClient({
      endpoint: `/admin/announcement/list`,
      method: 'POST',
      data: payload,
    }); 

    return response.data;
  };

  const updateStatus = async (payload: CraeteTitleCmsrDTO) => {
    const response = await apiClient({
      endpoint: `/admin/events/updatestatus`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

  const sendNotification = async (payload: any) => {
    const response = await apiClient({
      endpoint: `/admin/senddevicenotification`,
      method: 'POST',
      data: payload,
    });

    return response.data;
  };

 

  return {
    getAgentList,
    getCouponList,
    updateStatus,
    createNotificationType,
    createNotificationList,
    sendNotification
  };
};
